import { Input } from "@/components/ui/input"
import { Card, CardContent } from "@/components/ui/card"
import { Search } from "lucide-react"

interface SchoolSearchProps {
  value: string
  onChange: (value: string) => void
}

export function SchoolSearch({ value, onChange }: SchoolSearchProps) {
  return (
    <Card className="border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-sm">
      <CardContent className="p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 dark:text-slate-500" />
          <Input
            placeholder="Search by school name, location, or specialty..."
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="pl-10 bg-white dark:bg-slate-800 border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white placeholder:text-slate-500 dark:placeholder:text-slate-400 focus-visible:ring-purple-600 dark:focus-visible:ring-purple-500"
          />
        </div>
      </CardContent>
    </Card>
  )
}
